import { Controller } from "react-hook-form";
import { FormControlLabel, Switch } from "@mui/material";

export default function RHFToggle({
    name,
    control,
    label,
    defaultValue = false,
    labelPlacement = "start",
    ...props
}) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field, fieldState }) => (
                <FormControlLabel
                    control={
                        <Switch
                            {...props}
                            checked={!!field.value}
                            onChange={(e) => field.onChange(e.target.checked)}
                        />
                    }
                    labelPlacement={labelPlacement}
                    label={label}
                />
            )}
        />
    );
}
